var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpinsIcon = function SvgSpinsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.712 4.786c1.073-1.14 2.704-2.032 5.045-2.032 4.71 0 6.785 3.578 7.235 5.379a.5.5 0 1 1-.97.242 6.34 6.34 0 0 0-6.265-4.621c-2.058 0-3.428.774-4.317 1.718A5.8 5.8 0 0 0 4.216 7.49L5.6 7.03a.5.5 0 0 1 .316.948l-2.24.747a.5.5 0 0 1-.596-.213L1.833 6.519a.5.5 0 0 1 .848-.53l.643 1.028a6.8 6.8 0 0 1 1.388-2.231m10.59 10.436c-1.072 1.139-2.703 2.032-5.044 2.032-4.71 0-6.785-3.578-7.235-5.379a.5.5 0 1 1 .97-.242 6.34 6.34 0 0 0 6.265 4.621c2.058 0 3.427-.774 4.317-1.718a5.8 5.8 0 0 0 1.224-2.018l-1.383.46a.5.5 0 0 1-.317-.948l2.24-.747a.5.5 0 0 1 .597.213l1.245 1.993a.5.5 0 0 1-.848.53l-.642-1.029a6.8 6.8 0 0 1-1.388 2.232",
    clipRule: "evenodd"
  })));
};
export default SvgSpinsIcon;